import * as React from "react";

const SvgGameTime = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    fill="none"
  >
    <mask
      id="mask0_1393_13350"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={16}
      height={16}
    >
      <rect width="16" height="16" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_1393_13350)">
      <path
        d="M3.33333 5.33325H12.6667V3.99992H3.33333V5.33325ZM3.33333 14.6666C2.96667 14.6666 2.65278 14.536 2.39167 14.2749C2.13056 14.0138 2 13.6999 2 13.3333V3.99992C2 3.63325 2.13056 3.31936 2.39167 3.05825C2.65278 2.79714 2.96667 2.66659 3.33333 2.66659H4V1.33325H5.33333V2.66659H10.6667V1.33325H12V2.66659H12.6667C13.0333 2.66659 13.3472 2.79714 13.6083 3.05825C13.8694 3.31936 14 3.63325 14 3.99992V7.78325C13.7889 7.68325 13.5722 7.59992 13.35 7.53325C13.1278 7.46659 12.9 7.41659 12.6667 7.38325V6.66659H3.33333V13.3333H7.53333C7.61111 13.5777 7.70278 13.811 7.80833 14.0333C7.91389 14.2555 8.03889 14.4666 8.18333 14.6666H3.33333ZM12 15.3333C11.0778 15.3333 10.2917 15.0083 9.64167 14.3583C8.99167 13.7083 8.66667 12.9221 8.66667 11.9999C8.66667 11.0777 8.99167 10.2916 9.64167 9.64159C10.2917 8.99159 11.0778 8.66659 12 8.66659C12.9222 8.66659 13.7083 8.99159 14.3583 9.64159C15.0083 10.2916 15.3333 11.0777 15.3333 11.9999C15.3333 12.9221 15.0083 13.7083 14.3583 14.3583C13.7083 15.0083 12.9222 15.3333 12 15.3333ZM13.1167 13.5833L13.5833 13.1166L12.3333 11.8666V9.99992H11.6667V12.1333L13.1167 13.5833Z"
        fill="#F0F0F0"
      />
    </g>
  </svg>
);

export default SvgGameTime;
